import api from '../core/api';
import { ApiResponse } from '../core';
import VwStkHbsOrderDTO from 'src/models/StokEczane/OrderTalep/VwStkHbsOrderDTO';
import VwHbsorderhastaDTO from 'src/models/StokEczane/OrderTalep/VwHbsorderhastaDTO';
import { OrderTalepKabulEtIstek } from 'src/store/Slices/StokEczane/OrderTalepSlice';
import VwHbsOrderIlacDTO from 'src/models/Order/VwHbsOrderIlacDTO';
import VwHastaTumCikislarDTO from 'src/models/Order/VwHastaTumCikislarDTO';

const controllerName = 'OrderTalep';
export const OrderTalepApi = api.injectEndpoints({
    endpoints: (builder) => ({
        GetOrderTalepler: builder.query<Array<VwStkHbsOrderDTO>, {
            basTarih: string,
            bitTarih: string,
            organizasyonId: number,
            servisId: number,
            depoId?: number,
            iptal: boolean
        }>({
            query: (req) => ({
                url: controllerName + '/GetOrderTalepler',
                method: 'GET',
                params: {
                    basTarih: req.basTarih,
                    bitTarih: req.bitTarih,
                    organizasyonId: req.organizasyonId,
                    servisId: req.servisId,
                    depoId: req.depoId,
                    iptal: req.iptal
                }
            }),
        }),
        GetOrderIlac: builder.query<Array<VwHbsOrderIlacDTO>, {
            muracaatId?: number,
            servisId?: number,
            basTarih: string,
            bitTarih: string,
            depoId?: number,
            onayli: string,
            acil: string,
            tarihTip : string,
            iptalleriGetir? : string,
        }>({
            query: (req) => ({
                url: controllerName + '/GetOrderIlac',
                method: 'GET',
                params: req
            }),
        }),
        OrderTalepKabulEt: builder.mutation<boolean, OrderTalepKabulEtIstek>({
            query: (req) => ({
                url: controllerName + '/OrderTalepKabulEt',
                method: 'PUT',
                body: JSON.stringify(req),
            }),
        }),
        // List<VwHbsOrderIlacDTO> talepDetayList, decimal muracaatId, 
        // decimal orderDetayId, decimal depoTanimId, decimal organizasyonId, 
        // decimal teslimEdenId, decimal onayKullaniciId

        OrderDepoIlacRed: builder.mutation<ApiResponse<VwHbsOrderIlacDTO>, {
            ilac : VwHbsOrderIlacDTO,
            hastaId : number,
        }>(
            {
                query: (req) => ({
                    url: controllerName + '/OrderDepoIlacRed',
                    method: 'PUT',
                    body: JSON.stringify(req.ilac),
                    params: { hastaId : req.hastaId}
                })
            }
        ),
        OrderDepoIlacGuncelle: builder.mutation<ApiResponse<VwHbsOrderIlacDTO>, { request: Array<VwHbsOrderIlacDTO>, iptal: string, onayli: string }>(
            {
                query: (req) => ({
                    url: controllerName + '/OrderDepoIlacGuncelle',
                    method: 'PUT',
                    body: JSON.stringify(req.request),
                    params: { iptal: req.iptal, onayli : req.onayli }
                })
            }
        ),
        OrderHastaGetir: builder.query<Array<VwHbsorderhastaDTO>, {
            depoTanimId: number,
            basTarih: string,
            bitTarih: string,
            onayli: string,
            acil?: string
            hastamuracaatId?: number
            tarihTip: string,
            iptalleriGetir? : string,
        }>({
            query: (req) => ({
                url: controllerName + '/OrderHastaGetir',
                method: 'GET',
                params: req
            }),
            providesTags: ["StkOrderTalepHasta"]
        }),
        OrderTalepleriIlacGuncelle: builder.mutation<ApiResponse<VwHbsOrderIlacDTO>, VwHbsOrderIlacDTO>({
            query: (req) => ({
                url: controllerName + '/OrderTalepleriIlacGuncelle',
                method: 'PUT',
                body: JSON.stringify(req),
            }),
            invalidatesTags: ["StkOrderTalepIlac"]
        }),
        OrderHastaCikislariGetir: builder.query<Array<VwHastaTumCikislarDTO>, {muracaatId : number, kimlikId : number, iptalGosterme : string, hastayaAitCikislar : boolean}>({
            query: (req) => ({
                url: controllerName + '/OrderHastaCikislariGetir',
                method: 'GET',
                params: req
            }),
        }),
    })
});

export const {
    useGetOrderTaleplerQuery,
    useGetOrderIlacQuery,
    useLazyGetOrderIlacQuery,
    useOrderTalepKabulEtMutation,
    useOrderDepoIlacRedMutation,
    useLazyOrderHastaGetirQuery,
    useOrderDepoIlacGuncelleMutation,
    useOrderTalepleriIlacGuncelleMutation,
    useOrderHastaCikislariGetirQuery,
} = OrderTalepApi;
